import { Flex, Link, LoadingIcon, Message, Stack } from "basis";
import { Error } from "components/Error/Error";
import { EnhancedAccount } from "library/accounts/types";
import { AccountCard } from "./Account/AccountCard";

type Props = {
  accounts: EnhancedAccount[];
  accountsLoading: boolean;
  accountsError: boolean;
};

export const Notifications = ({
  accounts,
  accountsError,
  accountsLoading,
}: Props) => {
  if (accountsLoading) {
    return (
      <Flex
        height="200"
        placeItems="center"
        testId="notifications-page-loading"
      >
        <LoadingIcon size="medium" />
      </Flex>
    );
  }

  if (accounts.length === 0) {
    return (
      <Message
        severity="info-or-minor"
        bg="secondary.pink.t30"
        title="No accounts linked"
      >
        You do not currently have any accounts linked to the Latitude Service
        Centre.{" "}
        <Link href="/link-account" newTab={false}>
          Link account
        </Link>
      </Message>
    );
  }
  if (accountsError) {
    return <Error />;
  }

  return (
    <Stack gap="10">
      {accounts.map((account) => (
        <AccountCard account={account} key={account.account_id} />
      ))}
    </Stack>
  );
};
